/**
 * Auth session REST: login, logout, current admin (`GET /admin`).
 */
import Api from "@/api/Api";

export default {
  /** Admin login → `{ data: { token } }`. */
  login(data) {
    return Api().post("/login", data);
  },

  /** Invalidate server session (client still clears localStorage on logout). */
  logout() {
    return Api().post("/logout");
  },

  /** Current admin profile + settings (`GET /admin`). */
  auth() {
    return Api().get("/admin");
  }
};
